export interface BillingParty {
  name: string;
  street: string;
  city: string;
  ico: string;
  dic: string;
  email?: string;
  bankAccount: string;
  bankCode: string;
}

export const BILLING_SELLER: BillingParty = {
  name: "Algovectra s.r.o.",
  street: "Lidická 700/19",
  city: "602 00 Brno - Veveří",
  ico: "23437201",
  dic: "CZ23437201",
  email: "ronckova@centrum.cz",
  bankAccount: "6755607369",
  bankCode: "0800",
};

export const BILLING_BUYER: BillingParty = {
  name: "Vosime.cz Holding s.r.o.",
  street: "Příborská 2137",
  city: "738 01 Frýdek-Místek",
  ico: "05645654",
  dic: "CZ05645654",
  bankAccount: "",
  bankCode: "",
};

export const BILLING_CONSTANTS_SYMBOL = "0308";
export const BILLING_ISSUE_OFFSET_DAYS = 0;
export const BILLING_DUE_DAYS = 14;
export const BILLING_VAT_RATE = 0.21;
export const BILLING_UNIT_PRICE_CZK = 1.2;
export const BILLING_UNIT_LABEL = "ks";
export const BILLING_INVOICE_PREFIX = "FV";
export const BILLING_FILENAME_PREFIX = "Faktura";